import {Card,CardBody,CardHeader,Col,Container,Row} from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import Leftsideuser from "./Leftsideuser";
import TodoList from "./TodoList";
import AddTodo from "./AddTodo";

const TodoContain = () => {

  return (
    <Container fluid={true} className="email-wrap bookmark-wrap todo-wrap">
      <Breadcrumbs pageTitle="To-do" parent="Apps" title="To-do" />
      <Row>
        <Col xl="3" className="xl-30 box-col-30">
          <Leftsideuser />
        </Col>
        <Col xl="9" className="xl-70 box-col-70">
          <Card className="todo">
            <CardHeader className="b-bottom">
              <AddTodo />
            </CardHeader>
            <CardBody>
              <div className="todo">
                <div className="todo-list-wrapper">
                  <div className="todo-list-container">
                    <TodoList />
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default TodoContain;
